import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import NewsList from './NewsList';
import {withLocalize} from 'react-localize-redux';
import translations from '../../translations/translations_news_list';
import ReactHtmlParser from 'react-html-parser';

class NewsListContainer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        const pageTitle = this.props.translate('news_list.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'news-list'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <section id="news-list-title">
                        <div className="row row-title">
                            <div className="col col-md-12 col-sm-8">
                                <h1>{ReactHtmlParser(this.props.translate('news_list.title', null, {renderInnerHtml: false}))}</h1>
                            </div>
                        </div>
                    </section>

                    <NewsList/>
                </div>
            </Fragment>
        );
    }
}

NewsListContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(NewsListContainer);



// WEBPACK FOOTER //
// ./src/features/News/components/List/NewsListContainer.js